import { render, staticRenderFns } from "./contractor-sections.component.vue?vue&type=template&id=35a18653&"
import script from "./contractor-sections.component.vue?vue&type=script&lang=js&"
export * from "./contractor-sections.component.vue?vue&type=script&lang=js&"
import style0 from "./contractor-sections.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
